
let SETTINGS = undefined;

module.exports = {
    getSettings: () => SETTINGS,
    init: settings => SETTINGS = settings
}